var default_styles_default = {
  "button_container": "WJ9-R",
  "button_text": "SKNqk",
  "button_size_content": "sL8Zb"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
